/**
 *
 * Search Service Actions
 *
 */

import {
  SEARCH_REQUEST,
  NOT_ASKED,
  LOADING,
  SUCCESS,
  FAILURE,
} from './constants';

/**
 * Kicks off the saga that initiates the request.
 */
export function searchRequest(apexAccountNumber = '') {
  return {
    type: SEARCH_REQUEST,
    apexAccountNumber,
  };
}

/**
 * Used by the saga to set the status.
 */
export function notAsked() {
  return {
    type: NOT_ASKED,
  };
}

/**
 * Used by the saga to set the status and store params.
 */
export function loading(apexAccountNumber) {
  return {
    type: LOADING,
    apexAccountNumber,
  };
}

/**
 * Used by the saga to set the status and store results.
 */
export function success(results) {
  return {
    type: SUCCESS,
    results,
  };
}

/**
 * Used by the saga to set the status and store the error.
 */
export function failure(error) {
  return {
    type: FAILURE,
    error,
  };
}



// WEBPACK FOOTER //
// ./src/services/recentDeposits/actions.js